const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export const escapeHtml = (value = '') =>
  String(value).replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char] ?? char);

export const escapeHtmlAttribute = (value = '') => escapeHtml(value);

export const getMagicLinkEmailHtml = (magicLink = '') => {
  if (!magicLink) return '';

  return `<a href="${escapeHtmlAttribute(magicLink)}" style="color:#7F38E9;text-decoration:underline;">Access Your Dashboard</a>`;
};
